import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { faHeart as faHeartEmpty } from '@fortawesome/free-regular-svg-icons';
import { faHeart as faHeartFull } from '@fortawesome/free-solid-svg-icons';
import { OpenDialogHelpComponent } from 'app/components/dialog/open-dialog-help/open-dialog-help.component';
import { OpendialogLoginComponent } from 'app/components/dialog/open-dialog-login/opendialog-login.component';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { FormArticleByKey, FormDefinition } from 'app/shared/models/class/forms/form-definition';
import { Notice } from 'app/shared/models/class/notice/notice';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { OfferSession } from 'app/shared/models/class/session/session';
import { Tag } from 'app/shared/models/class/tags/tag';
import { CustomerDetails } from 'app/shared/models/class/user/user';
import { WishList } from 'app/shared/models/class/wishlist/wishlist';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { ColorService } from 'app/shared/services/color/color.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { FormService } from 'app/shared/services/forms/form.service';
import { NoticeService } from 'app/shared/services/notice/notice.service';
import { OfferFileService } from 'app/shared/services/offer-file/offer-file.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { SessionBasketService } from 'app/shared/services/session-basket/session-basket.service';
import { SessionService } from 'app/shared/services/session/session.service';
import { UsersService } from 'app/shared/services/users/users.service';
import { WishlistService } from 'app/shared/services/wishlist/wishlist.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { environment } from 'environments/environment';
import * as moment from 'moment';

@Component({
  selector: 'app-offer-details',
  templateUrl: './offer-details.component.html',
  styleUrls: ['./offer-details.component.scss']
})
export class OfferDetailsComponent extends SubscriptionBaseComponent implements OnInit {

  @Input() offerSub!: FullOffer;

  faHeartFull = faHeartFull;
  faHeartEmpty = faHeartEmpty;

  offer!: FullOffer;
  myWishes: FullOffer[] = [];
  myShoppingBag: FullOffer[] = [];
  userConnected!: InfosUser;
  sessions: OfferSession[] = [];
  club!: ClubDetails;
  files = [];
  univerTrain = 3;
  colorsTag: any;
  tags: Tag[] = [];
  image: any;
  carousel: any = [];
  slideIndex = 1;
  user!: CustomerDetails;
  externalLinks = [];

  isLoadingCarousel = false;
  userMail!: string;
  startDate!: string;
  endDate!: string;

  isDetailsImageOpen = false;
  notice!: Notice;
  associatedForm!: FormArticleByKey;
  form_url = environment.urlSite + `home/subscription-form`;

  constructor(
    private readonly offerService: OfferService,
    private readonly route: ActivatedRoute,
    private readonly dataService: DataService,
    private readonly authService: AuthService,
    private readonly dialog: MatDialog,
    private readonly cdr: ChangeDetectorRef,
    private readonly sessionBasketService: SessionBasketService,
    private readonly wishlistService: WishlistService,
    private readonly sessionService: SessionService,
    private readonly clubService: ClubService,
    private readonly offerFileService: OfferFileService,
    private readonly colorService: ColorService,
    private readonly domSanitizer: DomSanitizer,
    private readonly faIconService: FaiconService,
    private readonly usersService: UsersService,
    private readonly noticeService: NoticeService,
    private readonly formService: FormService,
    public router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.initComponent();
    this.initSub();
    this.getColorTags();
    this.getOfferById();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getDetails(offer: FullOffer): void {
    const params = {
      creationMode: true,
      offer: offer
    };
    this.offerService.setDataOffer(params);
    this.router.navigate(['admin/articles']);
  }

  getOfferById(): void {
    const { offerKey } = this.route.snapshot.queryParams;
    this.getCarouselPictures(+offerKey);

    if (+offerKey !== undefined) {
      this.getListFormsByArticleKey(+offerKey);
      this.offerService.getOfferById(+offerKey).subscribe({
        next: offer => {
          this.offer = offer;
          this.startDate = moment(this.offer.startDate).format('DD/MM/YYYY');
          this.endDate = moment(this.offer.endDate).format('DD/MM/YYYY');
          this.tags = offer.tags ? this.getTags(offer.tags) : [];
          if (offer.clubCode) {
            this.getClub(offer.clubCode);
          }
          if (this.offer.offerKey) {
            this.getExternalLinks(this.offer.offerKey);
          }
        }
      });
    } else {
      this.offer = this.offerSub;
    }
  }


  addOrDeleteToMyWish(offer: FullOffer, event: any): void {
    this.authService.refreshToken();
    const { offerKey } = offer;

    if (this.authService.isAuth()) {

      const { sub: userKey } = this.authService.getDecodedToken();
      const wishlistUpdate = new WishList(+userKey, []);

      this.myWishes.forEach(wish => {
        wishlistUpdate.offerKey.push(wish.offerKey);
      });

      const indexOfferInMyWishesUpdate = wishlistUpdate.offerKey.findIndex(o => o === offerKey);

      indexOfferInMyWishesUpdate === -1 ?
        (wishlistUpdate.offerKey.push(offerKey)) :
        (wishlistUpdate.offerKey.splice(indexOfferInMyWishesUpdate, 1));

      this.wishlistService.updateWishList(wishlistUpdate).subscribe({
        next: myWhishes => { this.dataService.myWishes.next(myWhishes); }
      });
    } else {
      const dialogRef = this.dialog.open(OpendialogLoginComponent);

      dialogRef.afterClosed().subscribe({
        next: () => {
          const { sub: userKey } = this.authService.getDecodedToken();
          const wishlistUpdate = new WishList(+userKey, []);

          this.myWishes.forEach(wish => {
            wishlistUpdate.offerKey.push(wish.offerKey);
          });

          const indexOfferInMyWishesUpdate = wishlistUpdate.offerKey.findIndex(o => o === offerKey);

          indexOfferInMyWishesUpdate === -1 ?
            (wishlistUpdate.offerKey.push(offerKey)) :
            (wishlistUpdate.offerKey.splice(indexOfferInMyWishesUpdate, 1));

          this.wishlistService.updateWishList(wishlistUpdate).subscribe({
            next: myWhishes => { this.dataService.myWishes.next(myWhishes); }
          });
        }
      });
    }

  }

  openSubscriptionForm(): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(
        ['/home/subscription-form'],
        {
          queryParams: {
            articleKey: this.offer.offerKey ? this.offer.offerKey.toString() : '',
          }
        }
      )
    );

    window.open(url, '_blank');
  }

  isInMyWishes(offerId: string): object {
    const indexOfferInMyWhishes = this.myWishes?.findIndex(o => o.offerKey === +offerId);
    return indexOfferInMyWhishes === -1 ? this.faHeartEmpty : this.faHeartFull;
  }

  isInMyWishesBoolean(offerId: string): boolean {
    const indexOfferInMyWhishes = this.myWishes?.findIndex(o => o.offerKey === +offerId);
    return indexOfferInMyWhishes === -1 ? false : true;
  }

  getColorOfHeart(offerId: string): string {
    const indexOfferInMyWhishes = this.myWishes?.findIndex(o => o.offerKey === +offerId);
    return indexOfferInMyWhishes === -1 ? '#2c296d' : '#ff0000';
  }

  addOrDeleteToMyShoppingBag(offer: FullOffer): void {
    this.authService.refreshToken();
    const { offerKey } = offer;

    if (this.authService.isAuth()) {

      const { sub: userKey } = this.authService.getDecodedToken();

      this.sessionBasketService.canAddToSessionBasket(+userKey, offerKey).subscribe({
        next: myShoppingBag => {
          this.router.navigate(['/home/my-shopping-bag']);
        }
      });

    } else {
      const dialogRef = this.dialog.open(OpendialogLoginComponent);
      dialogRef.afterClosed().subscribe({
        next: () => {
          const { sub: userKey } = this.authService.getDecodedToken();

          this.sessionBasketService.addInMyBasket(+userKey, offerKey).subscribe({
            next: myShoppingBag => {
              this.router.navigate(['/home/my-shopping-bag']);
            }
          });
        }
      });
    }
  }

  isInBasket(): boolean {
    const { offerKey } = this.route.snapshot.queryParams;
    const indexOffer = this.myShoppingBag?.findIndex(o => o.offerKey === +offerKey);
    return indexOffer === -1 ? false : true;
  }

  getNumberOfRow(): number {
    let count = 0;

    if (this.offer?.duration) {
      count++;
    }
    if (this.offer?.customerPromise) {
      count++;
    }
    if (this.offer?.informations) {
      count++;
    }
    if (this.offer?.services) {
      count++;
    }
    if (this.offer?.practicePlace) {
      count++;
    }
    if (this.offer?.environment) {
      count++;
    }
    if (this.offer?.prerequisites) {
      count++;
    }
    if (this.offer?.openingPeriod) {
      count++;
    }

    return Math.round(count / 2);
  }

  downloadFile(offerKey: number, offerFileKey: number, name: string): void {
    this.offerFileService.downloadFile(offerKey, offerFileKey).subscribe({
      next: (blob: any) => {

        const data = window.URL.createObjectURL(<any>blob.body);
        const anchor = document.createElement('a');
        anchor.href = data;
        anchor.download = name;
        anchor.click();

        setTimeout(() => {

          window.URL.revokeObjectURL(data);

        }, 100);
      }
    });
  }

  scrollTo(element: HTMLElement, position: HTMLElement): void {
    element.scrollTo({
      top: Math.round(this.getOffset(position).bottom),
      behavior: 'smooth'
    });
  }

  getUnivers(): boolean {

    const check = this.offer?.universes?.map(u => u.universeKey) || [];

    return check?.findIndex(u => u === this.univerTrain) !== -1;

  }

  getValueColorTag({ colorKey }): string {
    return '#' + this.colorsTag?.find(c => c.colorKey === colorKey)?.value + '!important';
  }

  getTags(tags: Tag[]): Tag[] {
    let tempoTag: any[] = [];

    for (let i = 1; i < this.colorsTag?.length + 1; i++) {
      const colorOrder = this.colorsTag.find(c => c.order === i);
      const tempo = tags.filter(t => t.colorKey === colorOrder.colorKey).sort((a, b) => (a.tagName.toLowerCase() as any) - (b.tagName.toLowerCase() as any));
      tempoTag = [...tempoTag, ...tempo];
    }

    return tempoTag;
  }

  getImg(): string {
    if (this.offer?.universes[0].universeKey === 1 || this.offer?.universes[0].universeKey === 3) {
      if (this.club?.logo) {
        return `data:image/png;base64,${this.club?.logo}`;
      } else {
        return '';
      }
    } else if (this.offer?.disciplinePicture) {
      return `data:image/png;base64,${this.offer?.disciplinePicture}`;
    } else {
      return `data:image/png;base64,${this.club?.logo}`;
    }
  }

  private getListFormsByArticleKey(articleKey: number): void {
    this.formService.getFormDefinitionByArticleKey(articleKey).subscribe({
      next: form => {
        this.associatedForm = form;
      }
    });
  }

  private getExternalLinks(articleKey: number): void {
    this.offerService.getBoundDocumentsByOfferKey(articleKey).subscribe({
      next: datas => {
        this.externalLinks = datas;
      }
    });
  }

  // private getImage(offerKey: number) {
  //   this.offerService.getImgOffer(offerKey).subscribe({
  //     next: image => {
  //       this.image = this.domSanitizer.bypassSecurityTrustUrl(`data:image/png;base64, ${image.pictureBase64}`);
  //     }
  //   });
  // }

  private getCarouselPictures(offerKey: number) {
    this.isLoadingCarousel = true;
    this.offerService.getCarouselPictures(offerKey).subscribe({
      next: carousel => {
        carousel.map((image: any, index: number) => {
          this.carousel.push({
            src: this.domSanitizer.bypassSecurityTrustUrl(`data:image/png;base64, ${image}`),
            selected: index === 0
          })
        })

        this.showSlides(this.slideIndex);
        this.isLoadingCarousel = false;
        setInterval(() => {
          this.plusSlides(1);
        }, 6000)
      }
    });
  }

  private getColorTags(): void {
    this.colorService.getColors().subscribe({
      next: colorsTag => this.colorsTag = colorsTag
    });
  }


  private getBasketList(): void {
    const { sub: userKey } = this.authService.getDecodedToken();
    this.sessionBasketService.getBasketList(+userKey).subscribe({
      next: basketList => {
        this.myShoppingBag = basketList;
        this.dataService.myShoppingBag.next(basketList);

        this.isInBasket();

      }
    });
  }

  private getSessionByClub(): void {
    const { offerKey } = this.route.snapshot.queryParams;
    this.sessionService.getSessionByOffer(+offerKey).subscribe({
      next: sessions => {
        this.sessions = sessions.filter(s => s.isActive && s.sessionStartDate.toString() !== '0001-01-01T00:00:00Z');
      }
    });
  }

  private getClub(clubCode: string): void {
    this.clubService.getClubDetails().subscribe({
      next: clubs => {
        this.club = clubs.find(c => c.clubCode === clubCode)!;
      }
    });
  }

  private getFilesByOffer(): void {
    const { offerKey } = this.route.snapshot.queryParams;
    this.offerFileService.getFiles(+offerKey).subscribe({
      next: files => this.files = files.result
    });
  }

  private getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      top: rect.top + window.scrollY,
      bottom: rect.bottom + window.scrollY
    };
  }

  private getUserDetails(userKey: number): void {
    this.usersService.getUserDetails(userKey).subscribe({
      next: data => {
        this.user = data;
        this.userMail = data.email!;
      }
    })
  }


  private initComponent(): void {
    this.dataService.tabHome$.next('other');
    this.dataService.titleHomePage.next('');
    this.userConnected = this.authService.getDecodedToken();
    if (this.userConnected) {
      const userKey = Number.parseInt(this.userConnected.sub);
      this.getUserDetails(userKey);
      this.getBasketList();
    }
    this.getSessionByClub();
    this.getFilesByOffer();
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.myWishes.subscribe({
          next: myWishes => { this.myWishes = myWishes; this.cdr.detectChanges(); }
        })
      )
      .add(
        this.dataService.myShoppingBag.subscribe({
          next: myShoppingBag => { this.myShoppingBag = myShoppingBag; this.cdr.detectChanges(); }
        })
      )
      .add(
        this.noticeService.detailsImage$.subscribe(data => {
          this.notice = data.notice;
          this.isDetailsImageOpen = data.bool;
          if (!this.isDetailsImageOpen) {
            this.initComponent();
          }
        })
      );

  }

  openDialogHelp() {
    this.dialog.open(OpenDialogHelpComponent, {
      data: { helpVideoKey: 2 },
      width: '60%',
      maxHeight: '90%'
    });
  }

  plusSlides(n) {
    this.showSlides(this.slideIndex += n);
  }

  currentSlide(n) {
    this.showSlides(this.slideIndex = n);
  }

  showSlides(n) {
    let i;
    let slides = this.carousel;

    if (n > slides.length) { this.slideIndex = 1 }
    if (n < 1) { this.slideIndex = slides.length }
    for (i = 0; i < slides.length; i++) {
      if (slides[i]) {
        slides[i].selected = false;
      }
    }

    if (slides[this.slideIndex - 1]) {
      slides[this.slideIndex - 1].selected = true;
    }
  }

}
